module.exports = __webpack_public_path__ + "img/vegetable-rapini-190x100.82aeab8d.jpg";